<template>
  <QToolbar>
    <QToolbarTitle class="flex">
      <router-link to="/" class="text-none text-grey-8 text-weight-bold flex">
        <img class="brand-logo" :src="organisationLogo" alt="Dragonball" />
      </router-link>
    </QToolbarTitle>
    <div class="row items-center">
      <QBtn
        v-if="$store.getters['quote/canCreate']"
        class="q-mr-sm"
        @click="createNewQuote"
        :to="{ name: 'quote', params: { quoteId: this.NewQuoteRouteParam } }"
        color="secondary"
        label="New Quote"
      />
      <EUIProfileMenu :title="this.$auth.user.name">
        <template slot="menu">
          <QList>
            <QItem v-close-popup clickable>
              <QItemSection @click="this.logout">Logout</QItemSection>
            </QItem>
          </QList>
        </template>
      </EUIProfileMenu>
    </div>
  </QToolbar>
</template>

<script>
import {
  QToolbar,
  QToolbarTitle,
  QBtn,
  QList,
  QItem,
  QItemSection,
  ClosePopup,
  EUIProfileMenu
} from 'eclipx.ui';
import { NewQuoteRouteParam } from '../../router/Routes';
import { mapState, mapMutations } from 'vuex';

/**
 * This component represents the header which is to be displayed as part of all page layouts.
 */
export default {
  name: 'Header',
  props: {
    title: String
  },
  data() {
    return {
      NewQuoteRouteParam: NewQuoteRouteParam,
      organisationLogoPlaceholder: `${process.env.BASE_URL}assets/logos/EclipxLogo-small.svg`
    };
  },
  computed: {
    ...mapState({ user: (state) => state.auth.user }),
    organisationLogo() {
      return (
        this?.user?.organisation?.org_branding?.logo ||
        this.organisationLogoPlaceholder
      );
    }
  },
  methods: {
    ...mapMutations({ createNewQuote: 'quote/createNewQuote' }),
    logout() {
      this.$router.push({ name: 'logout' });
    }
  },
  directives: {
    ClosePopup
  },
  components: {
    QBtn,
    QToolbar,
    QToolbarTitle,
    QList,
    QItem,
    QItemSection,
    EUIProfileMenu
  }
};
</script>

<style lang="sass" scoped>
.brand-logo
    height: 50px
</style>
